import ManageItemBadge from "@/v2-backoffice-client/components/manage/ManageItemBadge"
import ManageDialog from "@/v2-backoffice-client/components/manage/ManageDialog"
import ManageEmpty from "@/v2-backoffice-client/components/manage/ManageEmpty"
import ManageFooter from "@/v2-backoffice-client/components/manage/ManageFooter"
import ManageHint from "@/v2-backoffice-client/components/manage/ManageHint"
import ManageItem from "@/v2-backoffice-client/components/manage/ManageItem"
import ManageItemText from "@/v2-backoffice-client/components/manage/ManageItemText"
import ManageList from "@/v2-backoffice-client/components/manage/ManageList"
import ManageSearch from "@/v2-backoffice-client/components/manage/ManageSearch"
import ManageSection from "@/v2-backoffice-client/components/manage/ManageSection"
import ManageSkeleton from "@/v2-backoffice-client/components/manage/ManageSkeleton"

export type { ManageDialogProps } from "./ManageDialog"
export type { ManageSearchProps } from "./ManageSearch"
export type { ManageItemProps } from "./ManageItem"
export type { ManageSkeletonProps } from "./ManageSkeleton"
export type { ManageEmptyProps } from "./ManageEmpty"
export type { ManageHintProps } from "./ManageHint"
export type { ManageFooterProps } from "./ManageFooter"
export type { ManageSectionProps } from "./ManageSection"
export type { ManageListProps } from "./ManageList"

const Manage = {
  Dialog: ManageDialog,
  Section: ManageSection,
  List: ManageList,
  Search: ManageSearch,
  Skeleton: ManageSkeleton,
  Empty: ManageEmpty,
  Hint: ManageHint,
  Footer: ManageFooter,
  Item: Object.assign(ManageItem, {
    Text: ManageItemText,
    Badge: ManageItemBadge,
  }),
}

export default Manage
